import React from "react";
import { useAxios } from "../../../AxiosHandler";
import { toast } from 'react-toastify';

import styles from './FileUpload.module.scss';

function FileUpload(props: FileUploadProps) {
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    
    const hiddenFileInput = React.useRef(null);
    
    const handleClick = (event:any) => {
        if ( hiddenFileInput.current != null) {
            (hiddenFileInput.current as HTMLInputElement).click();
        }
    };

    const handleChange = (event:any) => {
        const fileUploaded = event.target.files[0];
        props.onChange(fileUploaded);
        props.uploadHandler?.(fileUploaded);
        if (props.uploadHandler == undefined) {
            uploadFileToCase();
        }
    };

    function uploadFileToCase() {
        toast.info("Laster opp fil ...", { autoClose: false });
        axios.single({
            url: "/api/files/",
            method: "POST",
            body: {
                documentType: props.documentType || undefined,
            }
        }).then((res: any) => {
            toast.dismiss();
            if(res.status !== 200) {
                toast.error("Opplasting av fil feilet! Vennligst prøv igjen");
                return;
            }
            toast.success("Opplasting fullført")
        }).catch((err: any) => {
            console.log(err);
            toast.dismiss();
            toast.error("Opplasting av fil feilet! Vennligst prøv igjen");
        });

    }
    
    return (
        <fieldset className="ffe-fieldset ffe-input-group">
            { props.title != undefined ?
                <legend className="ffe-form-label ffe-form-label--block">
                    { props.title }
                </legend>
            : null }
            { props.description != undefined ?
                <div className="ffe-small-text" style={{ marginBottom: "6px" }}>
                    { props.description }
                </div>
            : null }
            <div className={styles.border}>
                <div className={styles.fileuploadcontainer}>
                    <div 
                        className={styles.fileuploadbutton}
                        onClick={handleClick}
                    >
                        <input 
                            type="file"
                            accept=".pdf,.jpeg,.jpg,.png"
                            ref={hiddenFileInput}
                            onInput={(file: any) => handleChange(file)}
                            style={{display:'none'}} 
                        />
                        <p>
                            { props.buttontext || "Velg fil"}
                        </p>
                    </div>
                    <p>
                        PDF-filer, jpeg, png. Maks 25 MB
                    </p>
                </div>
            </div>
        </fieldset>
    );
}

class FileUploadProps{
    title?: string;
    description?: string;
    buttontext?: string;
    onChange!:  (file:any) => void;
    documentType?: string;
    uploadHandler?: (file:any) => void;
}

export default FileUpload;